// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"8e565d2c","178":"fa147ffb","186":"8c9c0134","278":"98daa670","562":"678f8da1","591":"041474ad","787":"0f46f545","811":"62003bdf"}[chunkId] + ".chunk.js";
};